import i18n from 'i18n/config';

export const AccountsTypes = {
  GET_ACCOUNTSLIST_DATA_REQUEST: 'GET_ACCOUNTSLIST_DATA_REQUEST',
  GET_ACCOUNTSLIST_DATA_SUCCESS: 'GET_ACCOUNTSLIST_DATA_SUCCESS',
  GET_ACCOUNTSLIST_DATA_FAILURE: 'GET_ACCOUNTSLIST_DATA_FAILURE',

  NUMBER_OF_ACCOUNTS_PER_PAGE: 80,
  INCREASE_ACCOUNTSLIST_PAGE: 'INCREASE_ACCOUNTSLIST_PAGE',

  SET_ACCOUNTS_SORTER: 'SET_ACCOUNTS_SORTER',
};

const tt = (key, defaultValue) => i18n.t(key, { defaultValue });

export const getIndustryTypes = (t = i18n.t.bind(i18n)) => ([
  { value: 'Power Generation', text: t('accounts.industry.powerGeneration', { defaultValue: 'Power Generation' }) },
  { value: 'Pharmaceuticals', text: t('accounts.industry.pharmaceuticals', { defaultValue: 'Pharmaceuticals' }) },
  { value: 'Oil and Gas', text: t('accounts.industry.oilAndGas', { defaultValue: 'Oil and Gas' }) },
  { value: 'Buildings and Facilties', text: t('accounts.industry.buildingsAndFacilities', { defaultValue: 'Buildings and Facilties' }) },
  { value: 'Food and Beverage', text: t('accounts.industry.foodAndBeverage', { defaultValue: 'Food and Beverage' }) },
  { value: 'Metals', text: t('accounts.industry.metals', { defaultValue: 'Metals' }) },
  { value: 'Others', text: t('accounts.industry.others', { defaultValue: 'Others' }) },
]);

// Deprecated: prefer getIndustryTypes(t).
export const INDUSTRY_TYPES = getIndustryTypes;
